import TrainingSessionLessonContent from '../session-lesson-content';

/**
 * Create the action
 */

const { thunk, request, success, error } = TrainingSessionLessonContent.destroy(({ trainingId, sessionId, lessonId, contentId }, fetch) => {
    return fetch.delete(`/trainings/${trainingId}/sessions/${sessionId}/lessons/${lessonId}/contents/${contentId}`);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };